import { Folder } from "lucide-react";
import { cn } from "@repo/utils";
import { ClearButton } from "../../button/components/clear-button.js";
import { HoverTooltip } from "../../ui/hover-tooltip.js";
import { inputVariants } from "../input-variants.js";
import type { Props as InputProps } from "../input.js";

type Props = Pick<InputProps, "variant" | "inputSize" | "className" | "disabled" | "error"> & {
  value?: string | null;
  placeholder: string;
  showClearIcon?: boolean;
  onClick: () => void;
  onClear: () => void;
};

export const DirectoryTrigger = ({
  value,
  placeholder,
  onClick,
  onClear,
  disabled,
  error,
  variant,
  inputSize,
  className,
  showClearIcon,
}: Props) => {
  return (
    <HoverTooltip
      content={value}
      wrapperClassName="flex w-full"
      className="max-w-[min(32rem,90vw)] break-all whitespace-normal"
    >
      <div
        className={cn(
          "group relative w-full",
          !disabled && "cursor-pointer",
          disabled && "cursor-not-allowed"
        )}
        onClick={() => {
          if (!disabled) onClick();
        }}
      >
        <div
          className={cn(
            inputVariants({ variant: error ? "error" : variant, inputSize }),
            "flex items-center truncate pr-16 text-gray-700 select-none",
            disabled && "cursor-not-allowed bg-gray-50 opacity-50",
            className
          )}
        >
          {value ? (
            <span className="truncate text-[12px]">{value}</span>
          ) : (
            <span className="min-w-0 text-[12px] text-gray-400">{placeholder}</span>
          )}
        </div>
        {!disabled && (
          <div className="absolute top-1/2 right-3 flex -translate-y-1/2 items-center gap-2">
            {showClearIcon && value && (
              <ClearButton
                onClick={(e) => {
                  e.stopPropagation();
                  onClear();
                }}
              />
            )}
            <Folder
              size={18}
              className="text-gray-400 transition-colors group-hover:text-gray-600"
            />
          </div>
        )}
      </div>
    </HoverTooltip>
  );
};
